module.exports = __webpack_public_path__ + "img/icon-coupon-yellow.1986a026.svg";